import getAxiosInstance from "../../common/mhiAxios";
import { SearchResult } from "../../viewer/search/Search";

export default {
    search(userId: string, keywords: string[]): Promise<SearchResult> {
        return getAxiosInstance()
            .get("/api/termSearch", {
                params: {
                    userId: userId,
                    keyword: keywords.join(","),
                },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
};
